// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/encryption/v1/encryption.proto" (package "agency.encryption.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
import { TraceContext } from "../../envelope/v1/envelope";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * PublicKeyEntry represents a registered AGE public key.
 *
 * @generated from protobuf message agency.encryption.v1.PublicKeyEntry
 */
export interface PublicKeyEntry {
    /**
     * entity_id uniquely identifies the key owner (user, service, node).
     *
     * @generated from protobuf field: string entity_id = 1
     */
    entityId: string;
    /**
     * pubkey_armored is the AGE public key in armored format.
     *
     * @generated from protobuf field: string pubkey_armored = 2
     */
    pubkeyArmored: string;
    /**
     * trust_level indicates the key's trust level.
     *
     * @generated from protobuf field: agency.encryption.v1.KeyTrustLevel trust_level = 3
     */
    trustLevel: KeyTrustLevel;
    /**
     * expires is the expiration time (required for EPHEMERAL keys).
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires = 4
     */
    expires?: Timestamp;
    /**
     * tenant scopes the key to a specific tenant (empty for global keys).
     *
     * @generated from protobuf field: string tenant = 5
     */
    tenant: string;
    /**
     * created_at is the key registration time.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * revoked indicates if the key has been revoked.
     *
     * @generated from protobuf field: bool revoked = 7
     */
    revoked: boolean;
    /**
     * revoked_at is the time the key was revoked (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Timestamp revoked_at = 8
     */
    revokedAt?: Timestamp;
}
/**
 * EncryptedEnvelope wraps sensitive data with multi-recipient AGE encryption.
 * Used for E2E encryption where NATS-level security is insufficient.
 *
 * @generated from protobuf message agency.encryption.v1.EncryptedEnvelope
 */
export interface EncryptedEnvelope {
    /**
     * age_ciphertext is the AGE-encrypted payload.
     *
     * @generated from protobuf field: bytes age_ciphertext = 1
     */
    ageCiphertext: Uint8Array;
    /**
     * recipient_ids are the entity IDs that can decrypt this payload.
     *
     * @generated from protobuf field: repeated string recipient_ids = 2
     */
    recipientIds: string[];
    /**
     * sender_id identifies the encrypting entity (for audit trail).
     *
     * @generated from protobuf field: string sender_id = 3
     */
    senderId: string;
    /**
     * content_type describes the encrypted payload type (e.g., "session.StepEvent").
     *
     * @generated from protobuf field: string content_type = 4
     */
    contentType: string;
    /**
     * trace_context is plaintext for routing (NATS needs this for subject routing).
     *
     * @generated from protobuf field: agency.envelope.v1.TraceContext trace_context = 5
     */
    traceContext?: TraceContext;
    /**
     * tenant is plaintext for NATS account routing.
     *
     * @generated from protobuf field: string tenant = 6
     */
    tenant: string;
    /**
     * workspace is plaintext for subject routing.
     *
     * @generated from protobuf field: string workspace = 7
     */
    workspace: string;
    /**
     * encrypted_at is the encryption timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp encrypted_at = 8
     */
    encryptedAt?: Timestamp;
    /**
     * key_fingerprints are SHA256 fingerprints of recipient pubkeys (for audit).
     *
     * @generated from protobuf field: repeated string key_fingerprints = 9
     */
    keyFingerprints: string[];
}
/**
 * RegisterRequest registers a new public key.
 *
 * @generated from protobuf message agency.encryption.v1.RegisterRequest
 */
export interface RegisterRequest {
    /**
     * entry is the public key entry to register.
     *
     * @generated from protobuf field: agency.encryption.v1.PublicKeyEntry entry = 1
     */
    entry?: PublicKeyEntry;
    /**
     * proof_of_possession is a signature proving control of the private key.
     *
     * @generated from protobuf field: bytes proof_of_possession = 2
     */
    proofOfPossession: Uint8Array;
}
/**
 * RevokeRequest revokes a public key.
 *
 * @generated from protobuf message agency.encryption.v1.RevokeRequest
 */
export interface RevokeRequest {
    /**
     * entity_id is the key owner to revoke.
     *
     * @generated from protobuf field: string entity_id = 1
     */
    entityId: string;
    /**
     * tenant scopes the revocation (empty for global).
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * reason describes why the key was revoked.
     *
     * @generated from protobuf field: string reason = 3
     */
    reason: string;
    /**
     * revoked_at is the revocation timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp revoked_at = 4
     */
    revokedAt?: Timestamp;
}
/**
 * LookupRequest requests public keys for encryption.
 *
 * @generated from protobuf message agency.encryption.v1.LookupRequest
 */
export interface LookupRequest {
    /**
     * entity_ids are the entities whose keys to retrieve.
     *
     * @generated from protobuf field: repeated string entity_ids = 1
     */
    entityIds: string[];
    /**
     * tenant scopes the lookup (empty for global).
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * exclude_revoked filters out revoked keys.
     *
     * @generated from protobuf field: bool exclude_revoked = 3
     */
    excludeRevoked: boolean;
    /**
     * min_trust_level filters by minimum trust level.
     *
     * @generated from protobuf field: agency.encryption.v1.KeyTrustLevel min_trust_level = 4
     */
    minTrustLevel: KeyTrustLevel;
}
/**
 * LookupResponse returns public keys.
 *
 * @generated from protobuf message agency.encryption.v1.LookupResponse
 */
export interface LookupResponse {
    /**
     * entries are the matching public key entries.
     *
     * @generated from protobuf field: repeated agency.encryption.v1.PublicKeyEntry entries = 1
     */
    entries: PublicKeyEntry[];
    /**
     * not_found are entity IDs with no matching keys.
     *
     * @generated from protobuf field: repeated string not_found = 2
     */
    notFound: string[];
}
/**
 * EdgeEncryptionConfig configures edge encryption requirements.
 *
 * @generated from protobuf message agency.encryption.v1.EdgeEncryptionConfig
 */
export interface EdgeEncryptionConfig {
    /**
     * require_age_for_tool_results enforces AGE encryption for tool results on edge/IoT nodes.
     *
     * @generated from protobuf field: bool require_age_for_tool_results = 1
     */
    requireAgeForToolResults: boolean;
    /**
     * keys_kv_bucket is the KV bucket name for key storage.
     *
     * @generated from protobuf field: string keys_kv_bucket = 2
     */
    keysKvBucket: string;
    /**
     * key_grace_window is the overlap period during key rotation.
     *
     * @generated from protobuf field: google.protobuf.Duration key_grace_window = 3
     */
    keyGraceWindow?: Duration;
    /**
     * enforce_node_kinds restricts enforcement to specific node types.
     *
     * @generated from protobuf field: repeated string enforce_node_kinds = 4
     */
    enforceNodeKinds: string[];
    /**
     * max_recipients_per_message limits multi-recipient encryption.
     *
     * @generated from protobuf field: int32 max_recipients_per_message = 5
     */
    maxRecipientsPerMessage: number;
}
/**
 * ResolveRequest resolves entities to encryption recipients.
 *
 * @generated from protobuf message agency.encryption.v1.ResolveRequest
 */
export interface ResolveRequest {
    /**
     * session_id identifies the session context.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * include_audit indicates if audit recipients should be included.
     *
     * @generated from protobuf field: bool include_audit = 4
     */
    includeAudit: boolean;
    /**
     * include_session_owner indicates if session owner should be included.
     *
     * @generated from protobuf field: bool include_session_owner = 5
     */
    includeSessionOwner: boolean;
    /**
     * additional_recipients are extra entity IDs to include.
     *
     * @generated from protobuf field: repeated string additional_recipients = 6
     */
    additionalRecipients: string[];
}
/**
 * ResolveResponse returns resolved recipient keys.
 *
 * @generated from protobuf message agency.encryption.v1.ResolveResponse
 */
export interface ResolveResponse {
    /**
     * recipients are the resolved public key entries.
     *
     * @generated from protobuf field: repeated agency.encryption.v1.PublicKeyEntry recipients = 1
     */
    recipients: PublicKeyEntry[];
    /**
     * unresolved_entities are entity IDs that could not be resolved.
     *
     * @generated from protobuf field: repeated string unresolved_entities = 2
     */
    unresolvedEntities: string[];
    /**
     * total_recipients is the count of resolved recipients.
     *
     * @generated from protobuf field: int32 total_recipients = 3
     */
    totalRecipients: number;
}
/**
 * RegisterResponse confirms key registration.
 *
 * @generated from protobuf message agency.encryption.v1.RegisterResponse
 */
export interface RegisterResponse {
    /**
     * entity_id is the registered entity.
     *
     * @generated from protobuf field: string entity_id = 1
     */
    entityId: string;
    /**
     * registered_at is when the key was registered.
     *
     * @generated from protobuf field: google.protobuf.Timestamp registered_at = 2
     */
    registeredAt?: Timestamp;
    /**
     * fingerprint is the SHA256 fingerprint of the registered key.
     *
     * @generated from protobuf field: string fingerprint = 3
     */
    fingerprint: string;
}
/**
 * RevokeResponse confirms key revocation.
 *
 * @generated from protobuf message agency.encryption.v1.RevokeResponse
 */
export interface RevokeResponse {
    /**
     * entity_id is the revoked entity.
     *
     * @generated from protobuf field: string entity_id = 1
     */
    entityId: string;
    /**
     * revoked_at is when the key was revoked.
     *
     * @generated from protobuf field: google.protobuf.Timestamp revoked_at = 2
     */
    revokedAt?: Timestamp;
}
/**
 * KeyTrustLevel defines the trust level of an encryption key.
 *
 * @generated from protobuf enum agency.encryption.v1.KeyTrustLevel
 */
export enum KeyTrustLevel {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: KEY_TRUST_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * EPHEMERAL keys are session-scoped and auto-expire.
     *
     * @generated from protobuf enum value: KEY_TRUST_LEVEL_EPHEMERAL = 1;
     */
    EPHEMERAL = 1,
    /**
     * DEVICE keys are bound to user devices.
     *
     * @generated from protobuf enum value: KEY_TRUST_LEVEL_DEVICE = 2;
     */
    DEVICE = 2,
    /**
     * SERVICE keys are for integration and service accounts.
     *
     * @generated from protobuf enum value: KEY_TRUST_LEVEL_SERVICE = 3;
     */
    SERVICE = 3,
    /**
     * TENANT keys are for tenant administrators.
     *
     * @generated from protobuf enum value: KEY_TRUST_LEVEL_TENANT = 4;
     */
    TENANT = 4,
    /**
     * OPERATOR keys are for harness node operators.
     *
     * @generated from protobuf enum value: KEY_TRUST_LEVEL_OPERATOR = 5;
     */
    OPERATOR = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class PublicKeyEntry$Type extends MessageType<PublicKeyEntry> {
    constructor() {
        super("agency.encryption.v1.PublicKeyEntry", [
            { no: 1, name: "entity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "pubkey_armored", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "10", maxLen: "1024" } } } },
            { no: 3, name: "trust_level", kind: "enum", T: () => ["agency.encryption.v1.KeyTrustLevel", KeyTrustLevel, "KEY_TRUST_LEVEL_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "expires", kind: "message", T: () => Timestamp },
            { no: 5, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "revoked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "revoked_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<PublicKeyEntry>): PublicKeyEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entityId = "";
        message.pubkeyArmored = "";
        message.trustLevel = 0;
        message.tenant = "";
        message.revoked = false;
        if (value !== undefined)
            reflectionMergePartial<PublicKeyEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PublicKeyEntry): PublicKeyEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string entity_id */ 1:
                    message.entityId = reader.string();
                    break;
                case /* string pubkey_armored */ 2:
                    message.pubkeyArmored = reader.string();
                    break;
                case /* agency.encryption.v1.KeyTrustLevel trust_level */ 3:
                    message.trustLevel = reader.int32();
                    break;
                case /* google.protobuf.Timestamp expires */ 4:
                    message.expires = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expires);
                    break;
                case /* string tenant */ 5:
                    message.tenant = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* bool revoked */ 7:
                    message.revoked = reader.bool();
                    break;
                case /* google.protobuf.Timestamp revoked_at */ 8:
                    message.revokedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.revokedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PublicKeyEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string entity_id = 1; */
        if (message.entityId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.entityId);
        /* string pubkey_armored = 2; */
        if (message.pubkeyArmored !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pubkeyArmored);
        /* agency.encryption.v1.KeyTrustLevel trust_level = 3; */
        if (message.trustLevel !== 0)
            writer.tag(3, WireType.Varint).int32(message.trustLevel);
        /* google.protobuf.Timestamp expires = 4; */
        if (message.expires)
            Timestamp.internalBinaryWrite(message.expires, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 5; */
        if (message.tenant !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tenant);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool revoked = 7; */
        if (message.revoked !== false)
            writer.tag(7, WireType.Varint).bool(message.revoked);
        /* google.protobuf.Timestamp revoked_at = 8; */
        if (message.revokedAt)
            Timestamp.internalBinaryWrite(message.revokedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.PublicKeyEntry
 */
export const PublicKeyEntry = new PublicKeyEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedEnvelope$Type extends MessageType<EncryptedEnvelope> {
    constructor() {
        super("agency.encryption.v1.EncryptedEnvelope", [
            { no: 1, name: "age_ciphertext", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "buf.validate.field": { bytes: { minLen: "1", maxLen: "10485760" } } } },
            { no: 2, name: "recipient_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 3, name: "sender_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9._]*[a-z0-9]$" } } } },
            { no: 5, name: "trace_context", kind: "message", T: () => TraceContext },
            { no: 6, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 7, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 8, name: "encrypted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "key_fingerprints", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { len: "64", pattern: "^[0-9a-f]{64}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<EncryptedEnvelope>): EncryptedEnvelope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ageCiphertext = new Uint8Array(0);
        message.recipientIds = [];
        message.senderId = "";
        message.contentType = "";
        message.tenant = "";
        message.workspace = "";
        message.keyFingerprints = [];
        if (value !== undefined)
            reflectionMergePartial<EncryptedEnvelope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EncryptedEnvelope): EncryptedEnvelope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes age_ciphertext */ 1:
                    message.ageCiphertext = reader.bytes();
                    break;
                case /* repeated string recipient_ids */ 2:
                    message.recipientIds.push(reader.string());
                    break;
                case /* string sender_id */ 3:
                    message.senderId = reader.string();
                    break;
                case /* string content_type */ 4:
                    message.contentType = reader.string();
                    break;
                case /* agency.envelope.v1.TraceContext trace_context */ 5:
                    message.traceContext = TraceContext.internalBinaryRead(reader, reader.uint32(), options, message.traceContext);
                    break;
                case /* string tenant */ 6:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 7:
                    message.workspace = reader.string();
                    break;
                case /* google.protobuf.Timestamp encrypted_at */ 8:
                    message.encryptedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.encryptedAt);
                    break;
                case /* repeated string key_fingerprints */ 9:
                    message.keyFingerprints.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EncryptedEnvelope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes age_ciphertext = 1; */
        if (message.ageCiphertext.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.ageCiphertext);
        /* repeated string recipient_ids = 2; */
        for (let i = 0; i < message.recipientIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.recipientIds[i]);
        /* string sender_id = 3; */
        if (message.senderId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.senderId);
        /* string content_type = 4; */
        if (message.contentType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.contentType);
        /* agency.envelope.v1.TraceContext trace_context = 5; */
        if (message.traceContext)
            TraceContext.internalBinaryWrite(message.traceContext, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 6; */
        if (message.tenant !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 7; */
        if (message.workspace !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.workspace);
        /* google.protobuf.Timestamp encrypted_at = 8; */
        if (message.encryptedAt)
            Timestamp.internalBinaryWrite(message.encryptedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated string key_fingerprints = 9; */
        for (let i = 0; i < message.keyFingerprints.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.keyFingerprints[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.EncryptedEnvelope
 */
export const EncryptedEnvelope = new EncryptedEnvelope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterRequest$Type extends MessageType<RegisterRequest> {
    constructor() {
        super("agency.encryption.v1.RegisterRequest", [
            { no: 1, name: "entry", kind: "message", T: () => PublicKeyEntry, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "proof_of_possession", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "buf.validate.field": { bytes: { minLen: "32", maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<RegisterRequest>): RegisterRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.proofOfPossession = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<RegisterRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterRequest): RegisterRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.encryption.v1.PublicKeyEntry entry */ 1:
                    message.entry = PublicKeyEntry.internalBinaryRead(reader, reader.uint32(), options, message.entry);
                    break;
                case /* bytes proof_of_possession */ 2:
                    message.proofOfPossession = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.encryption.v1.PublicKeyEntry entry = 1; */
        if (message.entry)
            PublicKeyEntry.internalBinaryWrite(message.entry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bytes proof_of_possession = 2; */
        if (message.proofOfPossession.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.proofOfPossession);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.RegisterRequest
 */
export const RegisterRequest = new RegisterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeRequest$Type extends MessageType<RevokeRequest> {
    constructor() {
        super("agency.encryption.v1.RevokeRequest", [
            { no: 1, name: "entity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "revoked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<RevokeRequest>): RevokeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entityId = "";
        message.tenant = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<RevokeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RevokeRequest): RevokeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string entity_id */ 1:
                    message.entityId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp revoked_at */ 4:
                    message.revokedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.revokedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RevokeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string entity_id = 1; */
        if (message.entityId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.entityId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp revoked_at = 4; */
        if (message.revokedAt)
            Timestamp.internalBinaryWrite(message.revokedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.RevokeRequest
 */
export const RevokeRequest = new RevokeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LookupRequest$Type extends MessageType<LookupRequest> {
    constructor() {
        super("agency.encryption.v1.LookupRequest", [
            { no: 1, name: "entity_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "exclude_revoked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "min_trust_level", kind: "enum", T: () => ["agency.encryption.v1.KeyTrustLevel", KeyTrustLevel, "KEY_TRUST_LEVEL_"] }
        ]);
    }
    create(value?: PartialMessage<LookupRequest>): LookupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entityIds = [];
        message.tenant = "";
        message.excludeRevoked = false;
        message.minTrustLevel = 0;
        if (value !== undefined)
            reflectionMergePartial<LookupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LookupRequest): LookupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string entity_ids */ 1:
                    message.entityIds.push(reader.string());
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* bool exclude_revoked */ 3:
                    message.excludeRevoked = reader.bool();
                    break;
                case /* agency.encryption.v1.KeyTrustLevel min_trust_level */ 4:
                    message.minTrustLevel = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LookupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string entity_ids = 1; */
        for (let i = 0; i < message.entityIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.entityIds[i]);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* bool exclude_revoked = 3; */
        if (message.excludeRevoked !== false)
            writer.tag(3, WireType.Varint).bool(message.excludeRevoked);
        /* agency.encryption.v1.KeyTrustLevel min_trust_level = 4; */
        if (message.minTrustLevel !== 0)
            writer.tag(4, WireType.Varint).int32(message.minTrustLevel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.LookupRequest
 */
export const LookupRequest = new LookupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LookupResponse$Type extends MessageType<LookupResponse> {
    constructor() {
        super("agency.encryption.v1.LookupResponse", [
            { no: 1, name: "entries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PublicKeyEntry },
            { no: 2, name: "not_found", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LookupResponse>): LookupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entries = [];
        message.notFound = [];
        if (value !== undefined)
            reflectionMergePartial<LookupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LookupResponse): LookupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.encryption.v1.PublicKeyEntry entries */ 1:
                    message.entries.push(PublicKeyEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string not_found */ 2:
                    message.notFound.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LookupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.encryption.v1.PublicKeyEntry entries = 1; */
        for (let i = 0; i < message.entries.length; i++)
            PublicKeyEntry.internalBinaryWrite(message.entries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string not_found = 2; */
        for (let i = 0; i < message.notFound.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.notFound[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.LookupResponse
 */
export const LookupResponse = new LookupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EdgeEncryptionConfig$Type extends MessageType<EdgeEncryptionConfig> {
    constructor() {
        super("agency.encryption.v1.EdgeEncryptionConfig", [
            { no: 1, name: "require_age_for_tool_results", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "keys_kv_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9._-]*[a-z0-9]$" } } } },
            { no: 3, name: "key_grace_window", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "enforce_node_kinds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "32", pattern: "^[A-Z_]+$" } } } } } },
            { no: 5, name: "max_recipients_per_message", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<EdgeEncryptionConfig>): EdgeEncryptionConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requireAgeForToolResults = false;
        message.keysKvBucket = "";
        message.enforceNodeKinds = [];
        message.maxRecipientsPerMessage = 0;
        if (value !== undefined)
            reflectionMergePartial<EdgeEncryptionConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EdgeEncryptionConfig): EdgeEncryptionConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool require_age_for_tool_results */ 1:
                    message.requireAgeForToolResults = reader.bool();
                    break;
                case /* string keys_kv_bucket */ 2:
                    message.keysKvBucket = reader.string();
                    break;
                case /* google.protobuf.Duration key_grace_window */ 3:
                    message.keyGraceWindow = Duration.internalBinaryRead(reader, reader.uint32(), options, message.keyGraceWindow);
                    break;
                case /* repeated string enforce_node_kinds */ 4:
                    message.enforceNodeKinds.push(reader.string());
                    break;
                case /* int32 max_recipients_per_message */ 5:
                    message.maxRecipientsPerMessage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EdgeEncryptionConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool require_age_for_tool_results = 1; */
        if (message.requireAgeForToolResults !== false)
            writer.tag(1, WireType.Varint).bool(message.requireAgeForToolResults);
        /* string keys_kv_bucket = 2; */
        if (message.keysKvBucket !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.keysKvBucket);
        /* google.protobuf.Duration key_grace_window = 3; */
        if (message.keyGraceWindow)
            Duration.internalBinaryWrite(message.keyGraceWindow, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated string enforce_node_kinds = 4; */
        for (let i = 0; i < message.enforceNodeKinds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.enforceNodeKinds[i]);
        /* int32 max_recipients_per_message = 5; */
        if (message.maxRecipientsPerMessage !== 0)
            writer.tag(5, WireType.Varint).int32(message.maxRecipientsPerMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.EdgeEncryptionConfig
 */
export const EdgeEncryptionConfig = new EdgeEncryptionConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveRequest$Type extends MessageType<ResolveRequest> {
    constructor() {
        super("agency.encryption.v1.ResolveRequest", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "include_audit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "include_session_owner", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "additional_recipients", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "256" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ResolveRequest>): ResolveRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.includeAudit = false;
        message.includeSessionOwner = false;
        message.additionalRecipients = [];
        if (value !== undefined)
            reflectionMergePartial<ResolveRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResolveRequest): ResolveRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* bool include_audit */ 4:
                    message.includeAudit = reader.bool();
                    break;
                case /* bool include_session_owner */ 5:
                    message.includeSessionOwner = reader.bool();
                    break;
                case /* repeated string additional_recipients */ 6:
                    message.additionalRecipients.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResolveRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* bool include_audit = 4; */
        if (message.includeAudit !== false)
            writer.tag(4, WireType.Varint).bool(message.includeAudit);
        /* bool include_session_owner = 5; */
        if (message.includeSessionOwner !== false)
            writer.tag(5, WireType.Varint).bool(message.includeSessionOwner);
        /* repeated string additional_recipients = 6; */
        for (let i = 0; i < message.additionalRecipients.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.additionalRecipients[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.ResolveRequest
 */
export const ResolveRequest = new ResolveRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveResponse$Type extends MessageType<ResolveResponse> {
    constructor() {
        super("agency.encryption.v1.ResolveResponse", [
            { no: 1, name: "recipients", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PublicKeyEntry, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 2, name: "unresolved_entities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_recipients", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<ResolveResponse>): ResolveResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.recipients = [];
        message.unresolvedEntities = [];
        message.totalRecipients = 0;
        if (value !== undefined)
            reflectionMergePartial<ResolveResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResolveResponse): ResolveResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.encryption.v1.PublicKeyEntry recipients */ 1:
                    message.recipients.push(PublicKeyEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string unresolved_entities */ 2:
                    message.unresolvedEntities.push(reader.string());
                    break;
                case /* int32 total_recipients */ 3:
                    message.totalRecipients = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResolveResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.encryption.v1.PublicKeyEntry recipients = 1; */
        for (let i = 0; i < message.recipients.length; i++)
            PublicKeyEntry.internalBinaryWrite(message.recipients[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string unresolved_entities = 2; */
        for (let i = 0; i < message.unresolvedEntities.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.unresolvedEntities[i]);
        /* int32 total_recipients = 3; */
        if (message.totalRecipients !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalRecipients);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.ResolveResponse
 */
export const ResolveResponse = new ResolveResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterResponse$Type extends MessageType<RegisterResponse> {
    constructor() {
        super("agency.encryption.v1.RegisterResponse", [
            { no: 1, name: "entity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "registered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "fingerprint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "64", pattern: "^[0-9a-f]{64}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RegisterResponse>): RegisterResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entityId = "";
        message.fingerprint = "";
        if (value !== undefined)
            reflectionMergePartial<RegisterResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterResponse): RegisterResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string entity_id */ 1:
                    message.entityId = reader.string();
                    break;
                case /* google.protobuf.Timestamp registered_at */ 2:
                    message.registeredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.registeredAt);
                    break;
                case /* string fingerprint */ 3:
                    message.fingerprint = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string entity_id = 1; */
        if (message.entityId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.entityId);
        /* google.protobuf.Timestamp registered_at = 2; */
        if (message.registeredAt)
            Timestamp.internalBinaryWrite(message.registeredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string fingerprint = 3; */
        if (message.fingerprint !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fingerprint);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.RegisterResponse
 */
export const RegisterResponse = new RegisterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeResponse$Type extends MessageType<RevokeResponse> {
    constructor() {
        super("agency.encryption.v1.RevokeResponse", [
            { no: 1, name: "entity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "revoked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<RevokeResponse>): RevokeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entityId = "";
        if (value !== undefined)
            reflectionMergePartial<RevokeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RevokeResponse): RevokeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string entity_id */ 1:
                    message.entityId = reader.string();
                    break;
                case /* google.protobuf.Timestamp revoked_at */ 2:
                    message.revokedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.revokedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RevokeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string entity_id = 1; */
        if (message.entityId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.entityId);
        /* google.protobuf.Timestamp revoked_at = 2; */
        if (message.revokedAt)
            Timestamp.internalBinaryWrite(message.revokedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.encryption.v1.RevokeResponse
 */
export const RevokeResponse = new RevokeResponse$Type();
/**
 * @generated ServiceType for protobuf service agency.encryption.v1.KeyResolverService
 */
export const KeyResolverService = new ServiceType("agency.encryption.v1.KeyResolverService", [
    { name: "Resolve", options: {}, I: ResolveRequest, O: ResolveResponse },
    { name: "Register", options: {}, I: RegisterRequest, O: RegisterResponse },
    { name: "Revoke", options: {}, I: RevokeRequest, O: RevokeResponse },
    { name: "Lookup", options: {}, I: LookupRequest, O: LookupResponse }
]);
